export default __webpack_public_path__ + "static/media/arbeitskleidung.d9decefd.svg";